export enum MenuButtonKeys {
  CUSTOMER_SUPPORT = 'HELP_CUSTOMER_SUPPORT',
  ACCESS_VALIDITY = 'HELP_ACCESS_VALIDITY',
  CANCEL_SUBSCRIPTION = 'HELP_CANCEL_SUBSCRIPTION',
  MANAGE_DEVICES = 'HELP_MANAGE_DEVICES',
  CALORIE_EXPENDITURE = 'HELP_CALORIE_EXPENDITURE',
  PLATFORM_ACCESS = 'HELP_PLATFORM_ACCESS',
  APP_VERSION = 'HELP_APP_VERSION',
}
